<template>
	<div class="sub-inverter row-center" style="justify-content: space-between">

		<div class="real-time-info">
			<div class="tit">
				<span>实时数据</span><span>{{currentLoop.label}}</span>
			</div>
			<div class="info column-center" style="justify-content: space-between">
				<div class="row row-center" style="justify-content: space-between">
					<div class="k">日发电量(kWh):</div>
					<div class="v">{{mqttval('Daily_Power_Generation')}}</div>
				</div>
				<div class="row row-center" style="justify-content: space-between">
					<div class="k">变流器效率(%):</div>
					<div class="v">--</div>
				</div>
				<div class="row row-center" style="justify-content: space-between">
					<div class="k">累计发电量(kWh):</div>
					<div class="v">{{mqttval('Total_Power_Generation')}}</div>
				</div>

			</div>

		</div>

		<div class="right">
			<div class="info-card row-center" style="justify-content: space-between">

				<div class="column-center" :class="{'P':index==0,'U':index==1,'I':index==2,'F':index==3}"  style="justify-content: flex-start" v-for="(item,index) in realData" >

					<div class="tit">
						{{item.type}}
					</div>

					<div class="column-center"
					     style="justify-content: space-between; align-items: flex-start;width: 100%;" v-if="index<=2">
						<div class="row row-center" style="justify-content: space-between" v-for="parm in item.details">
							<div class="k">{{parm.key}}<span v-if="parm.unit">({{parm.unit}})</span></div>
							<div class="v" >{{mqttval(parm.data,parm.multiple)}}</div>
						</div>
					</div>
					<div class="row-center hz" v-else>
						50
						<span>HZ</span>
					</div>

				</div>
				<!-- <div class="U column-center" style="justify-content: flex-start">

					<div class="tit">
						三相电压
					</div>

					<div class="column-center" style="justify-content: space-between; align-items: flex-start;width: 100%;">
						<div class="row row-center" style="justify-content: space-between">
							<div class="k">A(V):</div>
							<div class="v">400.2</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">B(V):</div>
							<div class="v">400.3</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">C(V):</div>
							<div class="v">400.6</div>
						</div>

					</div>


				</div>
				<div class="I column-center" style="justify-content: flex-start">

					<div class="tit">
						三相电流
					</div>

					<div class="column-center"
					     style="justify-content: space-between; align-items: flex-start;width: 100%;">
						<div class="row row-center" style="justify-content: space-between">
							<div class="k">A(A):</div>
							<div class="v" v-if="currentLoop.loopId==1">225.5</div>
							<div class="v" v-else>22.55</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">B(A):</div>
							<div class="v" v-if="currentLoop.loopId==1">225.5</div>
							<div class="v" v-else>22.54</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">C(A):</div>
							<div class="v" v-if="currentLoop.loopId==1">225.5</div>
							<div class="v" v-else>22.57</div>
						</div>

					</div>


				</div>
				<div class="F column-center" style="justify-content: flex-start">

					<div class="tit">
						电网频率
					</div>

					<div class="row-center hz">
						50
						<span>HZ</span>
					</div>

				</div> -->

			</div>

			<div class="other row-center" style="justify-content: space-between">
				<div>机内空气温度(℃)：<span>{{mqttval('Temperature')}}</span></div>
				<div>
					<button @click="isshow=!isshow;isCheck=0">查看MPPT</button>
					<button  @click="isshow=!isshow;isCheck=1">查看组串</button>
				</div>
			</div>

		</div>

		<Popup @checkClose="checkClose" v-if="isshow" :isCheck="isCheck" :currentLoop="currentLoop"></Popup>

	</div>
</template>

<script>
	import Popup from "../../views/battery/Popup.vue"
	import { floatFormat } from "../../util/MathUtil";
	export default {
		name: "SubInverter",
		props:{
			currentLoop:Object
		},
		components:{
			Popup
		},
		data(){
			return {
				isshow:false,
				isCheck:0,
				weather:""
			}
		},
		computed:{
			mqttval() {
				return this.getMqttVal(this.$store.getters.mqttVal);
			},
			realData(){
				return [
					{
						type: "功率",
						details: [{
								key: "功率因数",
								unit: "",
								data: "PF"
							},{
								key: "有功功率",
								unit: "kW",
								multiple: 0.001,
								data: "P"
							},
							{
								key: "无功功率",
								unit: "kVar",
								multiple: 0.001,
								data: "PR"
							},
							{
								key: "视在功率",
								unit: "kVA",
								multiple: 0.001,
								data: "PA"
							}
						]
					},{
						type: "三相电压",
						details: [{
								key: "A",
								unit: "V",
								data: "Ua"
							},{
								key: "B",
								unit: "V",
								data: "Ub"
							},
							{
								key: "C",
								unit: "V",
								data: "Uc"
							}
						]
					},{
						type: "三相电流",
						details: [{
								key: "A",
								unit: "A",
								data: "Ia"
							},{
								key: "B",
								unit: "A",
								data: "Ib"
							},
							{
								key: "C",
								unit: "A",
								data: "Ic"
							}
						]
					},{
						type: "电网频率",	
						details: [{
								unit: "HZ",
								data: "F"
							}
						]
					}
				]
			}	
		},
		mounted(){
			this.weather = this.$store.state.project.weather
		},
		methods:{
			
			getMqttVal(f) {
				let currentLoop = this.currentLoop
				return (k, m) => {
					if (currentLoop && k) {
						k = currentLoop.subLoopUrl + "/" + k;
						let mqttVal = f(k);
						if (m) {
							mqttVal *= m;
						}
						mqttVal = floatFormat(mqttVal, 2);
						if (typeof mqttVal === "object") {
							return mqttVal;
						}
						return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
					} else {
						return "--";
					}
				};
			},
			checkClose(state){
				this.isshow = state
			}
		}
	}
</script>

<style scoped lang="less">



	.sub-inverter {
		width: 100%;
		height: 35vh !important;

		.real-time-info,.right {
			height: 100% !important;
		}
		.real-time-info {
			background: #ffffff;
			width: 20.5vw;
			padding: 32rem 26rem;
			font-size: 21rem;
			font-weight: bold;
			color: #333333;

			.info {
				.row {
					width: 100%;

					margin-top: 50px;

					&:first-child {
						margin-top: 40px;
					}

					.k {
						font-size: 19rem;
						font-weight: bold;
						color: #333333;
					}

					.v {
						font-size: 27rem;
						font-weight: 400;
						color: #0D94FF;
					}
				}
			}

			.tit {
				padding-bottom: 8px;
				border-bottom: 1px solid rgba(0, 0, 0, 0.15);

				span {
					display: inline-block;
					height: 21rem;
					line-height: 21rem;

					&:first-child {
						border-right: 2px solid #333333;
						padding-right: 15px;
					}

					&:last-child {
						padding-left: 15px;
					}
				}
			}
		}

		.right {
			padding: 24px 16px;
			background: #ffffff;
			width: 45vw;

			.other {
				width: 100%;
				font-size: 21rem;
				font-weight: bold;
				color: #333333;
				margin-top: 27px;

				span {
					color: rgba(13, 148, 255, 1);
				}

				button {
					padding: 0 16px;
					margin-left: 7px;
					height: 34px;
					line-height: 34px;
					background: none;
					border: 1px solid rgba(0, 0, 0, .15);
					position: relative;
					cursor: pointer;
					font-size: 18rem;
					font-weight: bold;
					color: #333333;

					&:before {
						width: 15px;
						height: 15px;
						content: url("../../assets/img/lt.png");
						position: absolute;
						left: -2px;
						top: -2px;
						display: inline-block;
						line-height: 15px;

					}

					&:after {
						width: 15px;
						height: 15px;
						content: url("../../assets/img/lt.png");
						position: absolute;
						transform: rotate(180deg);
						right: -2px;
						bottom: -2px;
						display: inline-block;
						line-height: 15px;

					}
				}
			}

		}

		.info-card {
			width: 100%;
			line-height: 0;
			height: 82%;


			> div {
				width: 22%;
				padding: 24px 16px;
				height: 100%;
			}

			.tit {
				font-size: 22rem;
				line-height: 18px;
				font-weight: bold;
				color: #333333;
				margin-bottom: 20rem;
			}

			.P {
				width: 29%;
				background: rgba(0, 0, 0, 0.04) url("../../assets/img/p.png") center no-repeat;
			}

			.U {
				background: rgba(0, 0, 0, 0.04) url("../../assets/img/u.png") center no-repeat;
			}

			.I {
				background: rgba(0, 0, 0, 0.04) url("../../assets/img/i.png") center no-repeat;
			}

			.F {
				position: relative;
				background: rgba(0, 0, 0, 0.04) url("../../assets/img/h.png") center no-repeat;

				.hz {
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					font-size: 32rem;
					font-weight: 500;
					color: #0D94FF;

					span {
						font-size: 24rem;
					}
				}
			}

			.row {
				width: 100%;
				font-weight: 400;
				font-size: 18rem;
				line-height: 24rem;
				margin-top: 21rem;

				&:first-child {
					margin-top: 0;
				}

				.k {
					color: #333333;
				}

				.v {
					color: #0D94FF;
				}
			}
		}
	}
</style>
